import React from 'react';

import { Country } from './types';

interface Props {
  option: Country;
}

function countryToFlag(isoCode: string) {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode
        .toUpperCase()
        .replace(/./g, char =>
          String.fromCodePoint(char.charCodeAt(0) + 127397),
        )
    : isoCode;
}

const CountryCodeOption: React.FC<Props> = ({ option }) => (
  <React.Fragment>
    <span data-test-locator={`Flag ${option.code}`}>
      {countryToFlag(option.code)}
    </span>
    {option.code} {option.dialCode}
  </React.Fragment>
);

export default React.memo(CountryCodeOption);
